import React from "react";

const MVV = () => {
  return (
    <div className="w-[90%] mx-auto  gap-6 flex-wrap justify-between items-center my-10 flex ">
      <div className="bg-[#fff] flex-col flex justify-between p-8 w-[381px] h-[171px]">
        <h3 className="font-[700] text-[18px] sm:text-[23px] text-[#000] ">
          Our Mission
        </h3>
        <h4 className="font-[300] text-[12px] sm:text-[14px] text-[#000] sm:leading-[16px] ">
          Our mission is to be a global brand, delivering quality healthcare
          services beyond Nigeria to West Africa and beyond
        </h4>
      </div>
      <div className="bg-[#fff] flex-col flex justify-between p-8 w-[381px] h-[171px]">
        <h3 className="font-[700] text-[18px] sm:text-[23px] text-[#000] ">
          Our vision
        </h3>
        <h4 className="font-[300] text-[12px] sm:text-[14px] text-[#000] sm:leading-[16px] ">
          Our vision is to be a leading brand, distributing and marketing
          quality healthcare and wellness products that meet our customers'
          daily needs.
        </h4>
      </div>
      <div className="bg-[#fff] flex-col flex justify-between p-8 w-[381px] h-[171px]">
        <h3 className="font-[700] text-[18px] sm:text-[23px] text-[#000] ">
          Our core values
        </h3>
        <h4 className="font-[300] text-[12px] sm:text-[14px] text-[#000] sm:leading-[16px] ">
          Our core values guide everything we do, prioritizing the well-being of
          the people and communities we serve
        </h4>
      </div>
    </div>
  );
};

export default MVV;
